import styled from "@emotion/styled";
import { Box } from "@otrium/core";
import { Button } from "src/atoms/Button";

const Styledtitle = styled(Box)`
  font-size: ${({ theme }) => theme.fontSizes?.fontSize24};
  font-weight: bold;
  letter-spacing: 1.6px;
  line-height: 1.33;
  color: ${({ theme }) => theme.colors?.tone.black};
`;

const StyledButton = styled(Button)`
  width: 256px;
`;

export { Styledtitle, StyledButton };
